'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImageVignette = function ImageVignette(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 15c-4.42 0-8-2.69-8-6s3.58-6 8-6 8 2.69 8 6-3.58 6-8 6z' })
  );
};
ImageVignette = (0, _pure2.default)(ImageVignette);
ImageVignette.displayName = 'ImageVignette';
ImageVignette.muiName = 'SvgIcon';

exports.default = ImageVignette;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/image/vignette.js
 ** module id = 2167
 ** module chunks = 0
 **/